import { appStore } from "./modules/app";
import { errorLogStore } from "./modules/errorLog";
import { pageParaStore } from "./modules/pagePara";
import { permissionStore } from "./modules/permission";
import { settingStore } from "./modules/settings";
import { tagsViewStore } from "./modules/tagsView";
import { userStore } from "./modules/user";


const useStore = () => ({
  app: appStore(),
  errorLog: errorLogStore(),
  pagePara: pageParaStore(),
  permission: permissionStore(),
  setting: settingStore(),
  tagsView: tagsViewStore(),
  user: userStore(),
});

export default useStore;